import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toggleFavoriteAction } from '../actions/mvk_data';
import { FavoriteButton } from '../components/favorite_button';
export var FavoriteButtonContainer = connect(null, function (dispatch) {
  return {
    toggleFavorite: bindActionCreators(toggleFavoriteAction, dispatch)
  };
})(FavoriteButton);